import { ChangeEvent, FC, FocusEventHandler, memo, useMemo } from 'react'
import { PlanningApplicationStatus, allPlanningApplicationStatuses } from '@leadgen/models/client'
import Box from '@mui/material/Box'
import ApplicationStatusTile from './ApplicationStatusTile'

const ApplicationStatusGrid: FC<{
  planningApplicationStatuses: PlanningApplicationStatus[]
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
}> = ({ planningApplicationStatuses, onChange, onBlur }) => {
  const selectedPlanningApplicationStatusesSet = useMemo(() => {
    return new Set(planningApplicationStatuses)
  }, [planningApplicationStatuses])
  return (
    <Box
      component={'ul'}
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gap: 2,
        padding: 2,
        margin: 0,
      }}
    >
      {allPlanningApplicationStatuses.map(planningApplicationStatus => (
        <ApplicationStatusTile
          key={planningApplicationStatus}
          planningApplicationStatus={planningApplicationStatus}
          onChange={onChange}
          onBlur={onBlur}
          selected={selectedPlanningApplicationStatusesSet.has(planningApplicationStatus)}
        />
      ))}
    </Box>
  )
}

export default memo(ApplicationStatusGrid)
